import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/fonts.css';

// The website's SIGN IN link carries the theme it was showing (?theme=dark|light) so the
// app opens in the same one. Any other value is ignored; the parameter is then removed.
const params = new URLSearchParams(window.location.search);
if (params.has('theme')) {
  const linkedTheme = params.get('theme');
  if (linkedTheme === 'dark' || linkedTheme === 'light') localStorage.setItem('adgrow-theme', linkedTheme);
  params.delete('theme');
  const query = params.toString();
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
}

// Initialize theme from the user's saved preference (defaults to light)
const theme = localStorage.getItem('adgrow-theme') || 'light';
document.documentElement.setAttribute('data-theme', theme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
